let mixin = {
    data() {
        return {
            lang: 'zh',
        }
    },
    watch: {
        $route() {
            if (this.$route.query.l) {
                this.$i18n.locale = this.$route.query.l;
                this.lang = this.$route.query.l;
                localStorage.setItem("lang", this.$route.query.l);
            } else {
                this.lang = localStorage.getItem("lang") || "zh";
            }
        },
    },
    created() {
        // debugger
        // console.log('mixins')
        if (this.$route.query.l) {
            this.$i18n.locale = this.$route.query.l;
            this.lang = this.$route.query.l;
            localStorage.setItem("lang", this.$route.query.l);
        } else {
            this.lang = localStorage.getItem("lang") || "zh";
        }
    }
}
export default mixin;